import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { version } from "../version/version";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    bottom: "0",
    position: "fixed",
  },
}));

export default function Rodape(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>Ambiente: {process.env.REACT_APP_ENVIRONMENT}</div>

      <div>Versão: {version}</div>
      <div>
        <Typography variant="body2" color="textSecondary" align="center">
          {"Copyright © "}
          <Link color="inherit" href="http://www.ebco.com.br/">
            {new Date().getFullYear()} Copyright @ Ebco Systems Ltda. Todos os
            direitos reservados
          </Link>
        </Typography>
      </div>
    </div>
  );
}
